import { render, staticRenderFns } from "./last-location-cell.vue?vue&type=template&id=1af4dabd&scoped=true"
import script from "./last-location-cell.vue?vue&type=script&lang=js"
export * from "./last-location-cell.vue?vue&type=script&lang=js"
import style0 from "./last-location-cell.vue?vue&type=style&index=0&id=1af4dabd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af4dabd",
  null
  
)

export default component.exports